export enum CameraTimeZones {
  LOCAL = 'LOCAL',
  UTC = 'UTC',
}
